import React, { useEffect, useRef, useState } from "react";

export default function ReauthenticationModal({
  open,
  loading,
  error,
  onConfirm,
  onCancel,
}) {
  const [password, setPassword] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (!open) {
      setPassword("");
      return;
    }

    const timeoutId = window.setTimeout(() => inputRef.current?.focus(), 50);
    return () => window.clearTimeout(timeoutId);
  }, [open]);

  if (!open) return null;

  const submit = (event) => {
    event.preventDefault();
    if (!password || loading) return;
    onConfirm(password);
  };

  return (
    <div style={backdropStyle} role="presentation">
      <section
        style={cardStyle}
        role="dialog"
        aria-modal="true"
        aria-labelledby="zedro-reauth-title"
      >
        <div style={kickerStyle}>Protección de tu cuenta</div>
        <h2 id="zedro-reauth-title" style={titleStyle}>
          Confirma que eres tú
        </h2>
        <p style={copyStyle}>
          Esta operación modifica información sensible. Ingresa nuevamente tu
          contraseña para continuar.
        </p>

        <form onSubmit={submit}>
          <label style={labelStyle} htmlFor="zedro-reauth-password">
            Contraseña
          </label>
          <input
            ref={inputRef}
            id="zedro-reauth-password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            style={inputStyle}
            disabled={loading}
          />

          {error && <div style={errorStyle}>{error}</div>}

          <div style={actionsStyle}>
            <button
              type="button"
              onClick={onCancel}
              style={secondaryButtonStyle}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              style={primaryButtonStyle}
              disabled={loading || !password}
            >
              {loading ? "Confirmando…" : "Confirmar y continuar"}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
}

const backdropStyle = {
  position: "fixed",
  inset: 0,
  zIndex: 100000,
  display: "grid",
  placeItems: "center",
  padding: 18,
  background: "rgba(8, 25, 38, 0.58)",
  backdropFilter: "blur(5px)",
};

const cardStyle = {
  width: "min(100%, 440px)",
  padding: "26px 24px 22px",
  borderRadius: 24,
  background: "#ffffff",
  border: "1px solid rgba(40, 107, 148, 0.14)",
  boxShadow: "0 28px 80px rgba(8, 25, 38, 0.28)",
  fontFamily: "Questrial, sans-serif",
};

const kickerStyle = {
  color: "#c79a45",
  fontSize: 11,
  fontWeight: 900,
  letterSpacing: "0.11em",
  textTransform: "uppercase",
};

const titleStyle = {
  margin: "8px 0 8px",
  color: "#0f2f46",
  fontSize: 26,
  fontWeight: 500,
  letterSpacing: "-0.03em",
};

const copyStyle = {
  margin: "0 0 18px",
  color: "#64748b",
  fontSize: 14,
  lineHeight: 1.6,
};

const labelStyle = {
  display: "block",
  marginBottom: 7,
  color: "#264763",
  fontSize: 13,
  fontWeight: 800,
};

const inputStyle = {
  width: "100%",
  minHeight: 46,
  boxSizing: "border-box",
  padding: "0 13px",
  borderRadius: 13,
  border: "1px solid rgba(40, 107, 148, 0.25)",
  outline: "none",
  fontSize: 16,
};

const errorStyle = {
  marginTop: 10,
  padding: "9px 11px",
  borderRadius: 11,
  background: "#fff5f5",
  border: "1px solid rgba(180, 35, 24, 0.18)",
  color: "#b42318",
  fontSize: 13,
};

const actionsStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  marginTop: 18,
  flexWrap: "wrap",
};

const secondaryButtonStyle = {
  minHeight: 42,
  padding: "0 16px",
  borderRadius: 999,
  border: "1px solid #d8e1e8",
  background: "#ffffff",
  color: "#264763",
  fontWeight: 900,
  cursor: "pointer",
};

const primaryButtonStyle = {
  minHeight: 42,
  padding: "0 18px",
  borderRadius: 999,
  border: "none",
  background: "#286B94",
  color: "#ffffff",
  fontWeight: 900,
  cursor: "pointer",
};
